import { __require as requireFunctionUncurryThis } from './node_modules-core-js-internals-function-uncurry-this.js';

var classofRaw;
var hasRequiredClassofRaw;

function requireClassofRaw () {
	if (hasRequiredClassofRaw) return classofRaw;
	hasRequiredClassofRaw = 1;
	var uncurryThis = requireFunctionUncurryThis();

	var toString = uncurryThis({}.toString);
	var stringSlice = uncurryThis(''.slice);

	classofRaw = function (it) {
	  return stringSlice(toString(it), 8, -1);
	};
	return classofRaw;
}

export { requireClassofRaw as __require };
//# sourceMappingURL=node_modules-core-js-internals-classof-raw.js.map
